module.exports = {
  "country": "IL",
  "artist": "Yizhar Cohen & The Alpha-Beta",
  "song": "A-ba-ni-bi",
  "year": "1978",
  "place": "1",
  "spotify": "679myy6UyeEPmddFzTAoxE"
};